import store from "src/utils/redux/store";
import { addUrlSearchParamsDelimiter, reroll, setParam } from "./utils";
import { OffersParams } from "@pageDefinitions/goto/offers";

const telehealthRoot = (
  additionalQueryParams?: Record<string, string | number | boolean>
) => {
  const state = store.getState();
  const { userData } = state;

  const queryParams = new URLSearchParams(window.location.search);
  setParam(queryParams, "userId", userData.user_id);

  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const key in additionalQueryParams) {
    if (additionalQueryParams[key]) {
      setParam(queryParams, key, additionalQueryParams[key]);
    }
  }

  return `/telehealth/${addUrlSearchParamsDelimiter(queryParams)}`;
};

export default {
  insurance(noomPlanId?: string) {
    const additionalQueryParams = { noomPlanId };
    reroll(`${telehealthRoot(additionalQueryParams)}#/insurance`);
  },

  patientIntake(params: OffersParams) {
    const additionalQueryParams = {
      claimedByEmail: params.claimedByEmail,
      promoCode: params.promoCode,
      enrollmentResult: params.enrollmentResult,
    };
    reroll(`${telehealthRoot(additionalQueryParams)}#/patientIntake`);
  },

  schedule() {
    reroll(`${telehealthRoot()}#/schedule`);
  },

  reschedule() {
    reroll(`${telehealthRoot()}#/reschedule`);
  },
};
